import { useState } from 'react'
import { FaPen } from 'react-icons/fa'
import RoundedSelect from '../../Form/Fields/roundedSelect'
import { SCHOOL_DROPDOWN } from '../../../Utils/paymentUtils'
import { primary_color } from '../../../Helper/uiHelper'

const SchoolPenSelect = ({ schoolId, schoolName, logo, onChange }) => {
  const [open, setOpen] = useState(false)
  const [formData, setFormData] = useState([
    {
      domain_id: schoolId,
      domain_id_label: schoolName || '',
    },
  ])

  const handleFormChange = (updater) => {
    setFormData((prev) => {
      const next = typeof updater === 'function' ? updater(prev) : updater
      const row = next?.[0]
      if (row?.domain_id && String(row.domain_id) !== String(schoolId)) {
        onChange({ id: row.domain_id, name: row.domain_id_label })
        setOpen(false)
      }
      return next
    })
  }

  return (
    <div className='mb-3'>
      <div className='d-flex align-items-center'>
        {logo ? (
          <img
            src={logo}
            width='48'
            height='48'
            alt=''
            style={{ borderRadius: '50%', objectFit: 'cover', border: '1px solid #495057' }}
          />
        ) : null}
        <div className='d-flex align-items-center ml-3' style={{ gap: '0.6rem' }}>
          <div className='font-weight-bold body1 mb-0' style={{ color: '#495057' }}>
            {schoolName || 'School'}
          </div>
          <button
            type='button'
            aria-label='Change school'
            onClick={() => setOpen((value) => !value)}
            style={{
              border: 'none',
              background: 'transparent',
              color: primary_color,
              padding: 0,
              lineHeight: 1,
            }}>
            <FaPen />
          </button>
        </div>
      </div>
      {open && (
        <div className='mt-2' style={{ maxWidth: '280px' }}>
          <RoundedSelect
            data={SCHOOL_DROPDOWN}
            setFormData={handleFormChange}
            formFieldValue={formData?.[0]}
            formIndex={0}
            parentRequired={false}
            hideLabel
          />
        </div>
      )}
    </div>
  )
}

export default SchoolPenSelect
